/*
 *   Copyright (c) 2022 nVipani Technology Solutions Private Limited.
 *   All rights reserved.
 */
import { BREAKPOINT } from "@angular/flex-layout";

const SCREEN_BREAKPOINTS = [
  {
    alias: "lt-md",
    suffix: "ltMd",
    mediaQuery: "screen and (max-width: 1100px)",
    overlapping: false,
    priority: 1001, // Needed if overriding the default print breakpoint
  },
  {
    alias: "gt-sm",
    suffix: "gtSm",
    mediaQuery: "screen and (min-width: 1100px)",
    overlapping: false,
    priority: 1001, // Needed if overriding the default print breakpoint
  },
  {
    alias: "sm",
    suffix: "sm",
    mediaQuery: "screen and (min-width: 600px) and (max-width: 1100px)",
    overlapping: false,
    priority: 1001, // Needed if overriding the default print breakpoint
  },
];

export const CustomBreakPointsProvider = {
  provide: BREAKPOINT,
  useValue: SCREEN_BREAKPOINTS,
  multi: true,
};
